import React from 'react';
import './RelatedProducts.css';
import product_data from '../Assets/data';
import Item from '../Item/Item';

const RelatedProducts = () => {
    return (
        <div className="related-products">
                <h1>Related Products</h1>            
            <div className='related-products-items'>
                {product_data.map((item) => (
                    <Item 
                        key={item.id} 
                        id={item.id} 
                        name={item.name} 
                        image={item.image} 
                        new_price={item.new_price} 
                        old_price={item.old_price}
                        category={item.category}
                        isNew={true}
                    />
                ))}
            </div>
        </div>
    );
}

export default RelatedProducts;